import { Routes } from '@angular/router';
import { LayoutComponent } from '@layout/layout.component';

export const APP_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'results',
    pathMatch: 'full',
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'results',
        loadChildren: () =>
          import('@results/results.routes').then(m => m.RESULTS_ROUTES),
      },
      {
        path: 'booking-payments',
        loadChildren: () =>
          import('@booking-payments/booking-payments.routes').then(
            m => m.BOOKING_PAYMENTS_ROUTES
          ),
      },
      {
        path: 'confirmation',
        loadChildren: () =>
          import('@confirmation/confirmation.routes').then(
            m => m.CONFIRMATION_ROUTES
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'results',
  },
];
